import axios from 'axios'

const anonymousClient = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    AccessControlAllowMethods: 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
    AccessControlAllowHeaders: 'X-Requested-With, content-type, token, language',
    AccessControlAllowContentType: 'application/x-www-form-urlencoded',
    AccessControlAllowCredentials: 'true',
  },
 })

anonymousClient.interceptors.request.use(config => {
  return config
})

anonymousClient.interceptors.response.use(response => {
  return response
})

export default anonymousClient
